import { render, staticRenderFns } from "./TravelServiceEditView.vue?vue&type=template&id=13502457&scoped=true&"
import script from "./TravelServiceEditView.vue?vue&type=script&lang=js&"
export * from "./TravelServiceEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13502457",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13502457')) {
      api.createRecord('13502457', component.options)
    } else {
      api.reload('13502457', component.options)
    }
    module.hot.accept("./TravelServiceEditView.vue?vue&type=template&id=13502457&scoped=true&", function () {
      api.rerender('13502457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/travel-service/TravelServiceEditView.vue"
export default component.exports